import { FulfillmentOrderData } from "@redotech/redo-model/fulfillments/fulfillment-group";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";

export const ItemSKUColumn: Column2<FulfillmentOrderData> = {
  key: "item-sku",
  title: "Item SKU",
  renderNormalCell: ({ row }) => (
    <RedoTableTextCell
      text={
        row.items.length === 1
          ? (row.items?.[0]?.sku ?? "")
          : `${row.items.length} items`
      }
    />
  ),
  width: 80,
  alignment: ColumnAlignment.LEFT,
};
